import { render, staticRenderFns } from "./ChooseProjectDeliverableTypeModal.vue?vue&type=template&id=363b9b4f&scoped=true"
import script from "./ChooseProjectDeliverableTypeModal.vue?vue&type=script&lang=js"
export * from "./ChooseProjectDeliverableTypeModal.vue?vue&type=script&lang=js"
import style0 from "./ChooseProjectDeliverableTypeModal.vue?vue&type=style&index=0&id=363b9b4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363b9b4f",
  null
  
)

export default component.exports